
function syncBuyNow(form) {
  if (!form) return;

  const buyButton = form.querySelector('[data-buy-now]');
  const addButton = form.querySelector('button[name="add"]');
  const variant = form.querySelector('input[name="id"]');

  if (!buyButton || buyButton.dataset.loading === 'true') return;

  buyButton.disabled =
    !addButton ||
    addButton.disabled ||
    addButton.getAttribute('aria-disabled') === 'true' ||
    !variant ||
    variant.disabled ||
    !variant.value;
}

// Keep Buy It Now in sync with variant availability.
const buyNowObserver = new MutationObserver((mutations) => {
  for (const mutation of mutations) {
    const target = mutation.target;

    if (
      target instanceof Element &&
      target.matches(
        'product-form button[name="add"], product-form input[name="id"]'
      )
    ) {
      syncBuyNow(target.closest('form'));
    }
  }
});

buyNowObserver.observe(document.documentElement, {
  attributes: true,
  subtree: true,
  attributeFilter: ['disabled', 'aria-disabled']
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-buy-now]');

  if (!button || button.disabled || button.dataset.loading) return;

  const form = button.closest('form');
  if (!form) return;

  syncBuyNow(form);

  if (button.disabled || !form.reportValidity()) return;

  button.dataset.loading = 'true';
  button.disabled = true;

  try {
    const root = window.Shopify?.routes?.root || '/';

    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(
        error.description || error.message || 'Unable to add product'
      );
    }

    window.location.assign('/checkout');

  } catch (error) {
    console.error('Buy It Now error:', error);

    const wrapper = form.closest('product-form')
      ?.querySelector('.product-form__error-message-wrapper');

    const message = wrapper
      ?.querySelector('.product-form__error-message');

    if (wrapper && message) {
      message.textContent = error.message;
      wrapper.hidden = false;
    } else {
      alert(error.message);
    }

    delete button.dataset.loading;
    syncBuyNow(form);
  }
});
